import moment, { Moment } from "moment";
import { IGenericObject } from "../models/common";
import { LOCALSTORAGE_AUTH2 } from "../common/constants";
import Vue from "vue";
import { transform, isEqual, isObject } from 'lodash';
import { compareObject } from "./util";
export class DataHelper {
  /**
   *
   */
  constructor() { }

  static rootUrl;

  static getAuthData() {
    let authData = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
    return authData ? JSON.parse(authData) : {};
  }

  static getAuthorizationData() {
    return JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH2));
  }

  static getStaticRootUrl() {
    if (!this.rootUrl) {
      var authData = this.getAuthorizationData().information;

      if (!authData || location.port == "82") {
        this.rootUrl = "/static";
      } else {
        const baseTag = document.querySelector("meta[name='Base-Static-Url']");

        if (baseTag) {
          this.rootUrl = baseTag.getAttribute("content") + "static";
        }
        else {
          this.rootUrl = "//" + authData.originDomain + "/" + (authData.environment ? authData.environment + "/" : "") + authData.webAppVersion + "/static";
        }
      }
    }

    return this.rootUrl;
  }

  static removeTimeZone(date: string) {
    if (date == null) return null;
    return date.replace("T", " ").replace("Z", "");
  }
  static formatDateTime(moment: Moment) {
    if (moment == null) return null;
    return moment.format("YYYY-MM-DD HH:mm:ss");
  }
  static formatDate(moment: Moment) {
    if (moment == null) return null;
    return moment.format("YYYY-MM-DD");
  }
  static formatDateFromDate(date: Date) {
    if (date == null) return null;
    return moment(date).format("YYYY-MM-DD");
  }
  static formatTime(moment: Moment) {
    if (moment == null) return null;
    return moment.format("HH:mm");
  }
  static formatCurrentDay() {
    let momentForEnglish = moment();
    momentForEnglish.locale("en");
    return momentForEnglish.format("dddd");
  }
  static deepClone<T>(source: any): T {
    if (source === undefined) return undefined;
    const json = JSON.stringify(source);
    return JSON.parse(json);
  }
  // private getItems(source, id) {
  //   return source.filter(item => item.ParentId === id);
  // }
  static createTree<T>(source: IGenericObject[], beginningLevel: number): T[] {
    if (source !== null) {
      // const parentIds = Array.from(new Set(source.map(item => item.ParentId)));
      const descs = source
        .filter(s => s.ParentId === beginningLevel)
        .map(item => {
          return {
            label: item.NameEN,
            id: item.Id,
            children: source.filter(child => child.ParentId == item.Id)
          };
        });
      console.log(descs);
    }
    return [];
  }

  /** INIT ALL FIELDS FOR OBJECT TO AVOID UNDEFINE */
  static initObjectValue(source: any) {
    Object.keys(source).forEach(key => {
      let fieldValue = source[key];
      let type = typeof fieldValue;
      switch (type) {
        case "object":
          if (Array.isArray(fieldValue)) source[key] = [];
          else source[key] = {};
          break;
        case "string":
        case "number":
        case "boolean":
        case "undefined":
        default:
          source[key] = null;
      }
    });
  }

  /** MAPPING VALUE */
  static mappingObjectValue(source: any, destination: any) {
    if (source == null || destination == null) return;

    Object.keys(source).forEach(key => {
      destination[key] = source[key];
    });
  }

  static convertHourAndTime(
    value: string,
    duration: number,
    format?: string
  ): string {
    if (format === undefined) format = "HH:mm";
    let data = moment(value, format.toString());
    return data.add(duration, "m").format(format.toString());
  }

  static convertPostCodeToRegion(postCode: number): string {
    let _win = window as any;
    let LocationService = _win.Omnicasa.Services.LocationService;

    return LocationService.convertPostCodeToRegion(postCode);
  }

  static containsAny(str, substrings) {
    for (var i = 0; i != substrings.length; i++) {
      var substring = substrings[i];
      if (str.indexOf(substring) != -1) {
        return substring;
      }
    }
    return null;
  }

  static treeify(
    list,
    idAttr = "id",
    parentAttr = "parentId",
    childrenAttr = "children"
  ) {
    var treeList = [];
    var lookup = {};
    list.forEach(function (obj) {
      obj[childrenAttr] = [];
      lookup[obj[idAttr]] = obj;
    });

    list.forEach(function (obj) {
      if (obj?.[parentAttr] != null && obj?.[parentAttr] != 0) {
        if (typeof lookup[obj?.[parentAttr]]?.[childrenAttr] !== undefined) {
          lookup[obj?.[parentAttr]]?.[childrenAttr].push(obj);
        } else {
          lookup[obj[parentAttr]][childrenAttr] = [obj];
        }
      } else {
        treeList.push(obj);
      }
    });
    return treeList;
  }

  static groupBy(items, key) {
    return items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [
          ...(result[item[key]] || []),
          item,
        ],
      }),
      {},
    );
  }

  static insertAndShift(arr, from, to) {
    let cutOut = arr.splice(from, 1)[0]; // cut the element at index 'from'
    arr.splice(to, 0, cutOut);            // insert it at index 'to'
  }

  static mergeData(obj: any, mergeObj: any) {
    for (var k in mergeObj) {
      Vue.set(obj, k, mergeObj[k]);
    }
  }

  static difference(object, base) {
    const normalizedObject = this.normalizeDiffTarget(object, base);
    const normalizedBase = this.normalizeDiffTarget(base, object);

    if (
      typeof normalizedObject !== 'object' &&
      typeof normalizedObject !== 'string'
    ) {
      return isEqual(normalizedObject, normalizedBase) ? {} : normalizedObject;
    }

    return transform(
      normalizedObject,
      (result, value, key) => {
        const baseValue = this.getDiffComparableValue(normalizedBase, key);
        if (!isEqual(value, baseValue)) {
          const shouldRecurse = isObject(value) && isObject(baseValue);
          result[key] = shouldRecurse ? this.difference(value, baseValue) : value;
        }
      },
      Array.isArray(normalizedObject) ? [] : {}
    );
  }

  private static normalizeDiffTarget(target: any, fallbackShape: any) {
    if (target !== undefined && target !== null) {
      return target;
    }

    if (fallbackShape === undefined || fallbackShape === null) {
      return {};
    }

    if (Array.isArray(fallbackShape)) return [];
    if (typeof fallbackShape === 'string') return '';
    if (typeof fallbackShape === 'object') return {};

    return {};
  }

  private static getDiffComparableValue(target: any, key: string | number) {
    if (target === undefined || target === null) return undefined;
    if (typeof target === 'string') {
      const index = typeof key === 'number' ? key : parseInt(key as string, 10);
      return Number.isNaN(index) ? undefined : target[index];
    }
    return target[key];
  }

  static compare(object, base) {
    let compare = false;
    compare = compareObject(object, base);
    return compare;
  }

  static compareTextarea(txt, txtBase) {
    if (typeof(txt) !== "string" || typeof(txtBase) !== "string") return true;
    
    const arr = txt.replace("\r\n", "\n").split("\n");
    const base = txtBase.replace("\r\n", "\n").split("\n");
    let compare = true;
    compare = JSON.stringify(arr) === JSON.stringify(base)
    return !compare;
  }

  static normalizeUniqueCode(value: string) {
    if (value == null) return null;
    // remove everything forbidden by XML 1.0 specifications, plus the unicode replacement character U+FFFD
    var xmlForbiddenRegex = /([^\x09\x0A\x0D\x20-\uD7FF\uE000-\uFFFC\u{10000}-\u{10FFFF}])/ug;
 
    // remove everything not suggested by XML 1.0 specifications
    const xmlNotSuggestedRegex = /([\x7F-\x84]|[\x86-\x9F]|[\uFDD0-\uFDEF]|[\u{1FFFE}-\u{1FFFF}]|[\u{2FFFE}-\u{2FFFF}]|[\u{3FFFE}-\u{3FFFF}]|[\u{4FFFE}-\u{4FFFF}]|[\u{5FFFE}-\u{5FFFF}]|[\u{6FFFE}-\u{6FFFF}]|[\u{7FFFE}-\u{7FFFF}]|[\u{8FFFE}-\u{8FFFF}]|[\u{9FFFE}-\u{9FFFF}]|[\u{AFFFE}-\u{AFFFF}]|[\u{BFFFE}-\u{BFFFF}]|[\u{CFFFE}-\u{CFFFF}]|[\u{DFFFE}-\u{DFFFF}]|[\u{EFFFE}-\u{EFFFF}]|[\u{FFFFE}-\u{FFFFF}]|[\u{10FFFE}-\u{10FFFF}].)/ug;

    const specialChar = "&#x0;";
    return value.replace(specialChar, '').replace(xmlForbiddenRegex, '').replace(xmlNotSuggestedRegex, '');
  }
}
